import React, { useEffect, useState, useCallback } from "react";
import OptionalProductItem from "./OptionalProductItem";
import ProductModalWithButton from "./ProductModalWithButton";
import { Modal } from "react-bootstrap";
import AttentionIcon from "../../assets/images/attention-icon.png";

const EMPTY_ARRAY = [];

function RateDetail({
  canShowSelectionAlert = true,
  chosenComponents = EMPTY_ARRAY,
  componentsOrdered = [],
  deductible,
  onTotalChange = () => {},
  products,
  rate,
  shouldShow = true,
  selectedProgram,
  setChosenComponents = () => {},
  setSelectedProgram,
  term,
}) {
  const [total, setTotal] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [localChosen, setLocalChosen] = useState(chosenComponents);
  const isSelectedProgram = selectedProgram?.id === rate?.id;

  // Sync local state when parent updates chosenComponents (e.g. term/deductible change in Per Component)
  useEffect(() => {
    setLocalChosen(chosenComponents);
  }, [chosenComponents]);

  const getProductName = (currentProduct) => {
    return currentProduct.name.replace(/Component : /g, "");
  };

  componentsOrdered.forEach((component, key) => {
    if (component === "Tech") return;
    if (
      !rate?.products.find((product) => getProductName(product) === component)
    ) {
      rate?.products.push({
        id: key,
        name: component,
        required: false,
        disabled: true,
      });
    }
  });
  const sortedProducts = rate?.products.sort((a, b) => {
    const aIndex = componentsOrdered.findIndex((order) =>
      a.name.includes(order)
    );
    const bIndex = componentsOrdered.findIndex((order) =>
      b.name.includes(order)
    );
    return aIndex - bIndex;
  });

  const getProductDescription = (productName) => {
    const matchedSubtype = products[0].subtypes.find(
      (subtype) => subtype.name === productName
    );
    return matchedSubtype?.coverage_description !== null
      ? matchedSubtype.coverage_description
      : matchedSubtype.description;
  };

  const handleRadioChange = (e) => {
    let newRate = rate;
    if (!e.target.checked) {
      newRate = null;
    }
    setSelectedProgram(newRate);
  };

  const updateTotal = useCallback((currentRate, chosen) => {
    let currentTotal = currentRate.retail_price || currentRate.cost;
    currentRate.products.forEach((product) => {
      if (product.required === false && chosen.includes(product.id)) {
        const priceIncrease = product.retail_price || product.cost;
        currentTotal += priceIncrease;
      }
    });
    setTotal(currentTotal);
  }, []);

  const handleSwitchChange = (e) => {
    const id = parseInt(e.target.value);
    let newChosen;
    if (e.target.checked) {
      newChosen = [...localChosen, id];
      setChosenComponents([...chosenComponents, id]);
      const techIds = (rate?.products ?? [])
        .filter((p) => p.name.includes("Tech"))
        .map((p) => p.id);
      if (canShowSelectionAlert && !techIds.includes(id)) {
        const nonTechCount = newChosen.filter((cid) => !techIds.includes(cid)).length;
        if (nonTechCount > 3) {
          setShowAlert(true);
        }
      }
    } else {
      newChosen = localChosen.filter((cid) => cid !== id);
      setChosenComponents(chosenComponents.filter((cid) => cid !== id));
    }
    setLocalChosen(newChosen);
    updateTotal(rate, newChosen);
  };

  useEffect(() => {
    if (rate) {
      updateTotal(rate, localChosen);
    }
  }, [rate, localChosen, updateTotal]);

  useEffect(() => {
    if (rate) {
      onTotalChange(rate.id, total);
    }
  }, [rate, total, onTotalChange]);

  return (
    <div
      className={`rate-detail ${shouldShow ? "" : "d-none"} ${
        !isSelectedProgram && selectedProgram !== null ? "disabled" : ""
      }`}
    >
      {sortedProducts?.map((product) => (
        <div key={product.id} id={product.id}>
          {product.disabled === true ? (
            <div className="product d-flex lh-1 p-2 mb-3 disabled">
              <div className="col">{getProductName(product)}</div>
              <ProductModalWithButton
                productId={product.id}
                productDescription={getProductDescription(
                  getProductName(product)
                )}
                productName={getProductName(product)}
              />
            </div>
          ) : !product.required ? (
            <OptionalProductItem
              handleSwitchChange={handleSwitchChange}
              isChosen={localChosen.includes(product.id)}
              productId={product.id}
              productDescription={getProductDescription(
                getProductName(product)
              )}
              productName={getProductName(product)}
            />
          ) : (
            <div className="product d-flex lh-1 p-2 mb-3 active">
              <div className="col">{getProductName(product)}</div>
              <ProductModalWithButton
                productId={product.id}
                productDescription={getProductDescription(
                  getProductName(product)
                )}
                productName={getProductName(product)}
              />
            </div>
          )}
        </div>
      ))}
      {rate ? (
        <div className={`pricing d-flex`}>
          <input
            className="form-check-input me-2"
            id={`rate-${rate.id}`}
            type="checkbox"
            onClick={handleRadioChange}
            onChange={() => {}}
            checked={isSelectedProgram ? "checked" : ""}
          />
          <label htmlFor={`rate-${rate.id}`}>
            Total: ${total.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </label>
        </div>
      ) : (
        <p>
          Not Available for {term} months with ${deductible} deductible
        </p>
      )}
      <Modal
        show={showAlert}
        onHide={() => setShowAlert(false)}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            <img
              src={AttentionIcon}
              alt="attention icon"
              className="me-2"
              width={40}
            />
            <strong>Attention</strong>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Based on your selections, please consider the Full Affordable
            Option, or the initial offering.
          </p>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default RateDetail;
